module.exports = __webpack_public_path__ + "img/atacama.0eac7651.jpeg";